/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';

import { BaseDesignDetails, BaseDesignListItemDto } from './base-design.dto';
import { Storeys } from '../leads';

export const BaseDesignListItemMapper = entity<BaseDesignListItemDto>(
  {
    storeys: enumeration(Storeys),
  });
export const BaseDesignDetailsMapper = entity<BaseDesignDetails>(
  {
    storeys: enumeration(Storeys),
  });
